import React, { useState } from 'react';
import SEOHead from '../components/SEOHead';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic will be added here
    alert('Thank you for contacting us! We will get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <>
      <SEOHead 
        title="Contact Us - YT DOWN | Free YouTube & TikTok Video Downloader Support"
        description="Get in touch with YT DOWN support team. Questions about downloading YouTube or TikTok videos? Need help with HD downloads or watermark removal? We're here to help. Fast response, friendly support."
        keywords="contact yt down, youtube downloader support, tiktok downloader help, video downloader contact, download support, technical support, customer service, video download help"
        url="https://digimac.pro/contact"
      />
      <section id="contact" className="contact-section">
      <div className="contact-container">
        {/* Hero Section */}
        <div className="contact-hero">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-subtitle">
            Get Help with YouTube & TikTok Video Downloads
          </p>
        </div>

        <div className="contact-content">
          {/* Introduction */}
          <div className="intro-block">
            <h2>We're Here to Help</h2>
            <p>
              Welcome to YT DOWN support! Whether you're experiencing issues with downloading 
              YouTube videos, TikTok videos without watermark, or have questions about our free 
              online video downloader service, we're here to assist you. Our team is dedicated 
              to providing fast and helpful support for all your video downloading needs.
            </p>
          </div>

          {/* Support Categories */}
          <div className="support-categories">
            <div className="category-card">
              <div className="category-icon">🎬</div>
              <h3>YouTube Download Support</h3>
              <p>
                Having trouble downloading YouTube videos? Issues with HD quality downloads, 
                MP4 format, or video quality selection? We can help resolve YouTube downloader 
                errors, broken links, and download failures.
              </p>
            </div>

            <div className="category-card">
              <div className="category-icon">🎵</div>
              <h3>TikTok Download Support</h3>
              <p>
                Need assistance with TikTok video downloads? Problems with watermark removal, 
                video quality, or TikTok URL not working? Contact us for help with TikTok 
                downloader issues and no watermark downloads.
              </p>
            </div>

            <div className="category-card">
              <div className="category-icon">🐛</div>
              <h3>Report Broken Links</h3>
              <p>
                Found a broken download link or experiencing errors? Report technical issues, 
                failed downloads, or website bugs. Help us improve our YouTube and TikTok 
                video downloader service.
              </p>
            </div>

            <div className="category-card">
              <div className="category-icon">💡</div>
              <h3>Feedback & Suggestions</h3>
              <p>
                Have ideas to improve our free online video downloader? Want to suggest new 
                features or platforms? Share your feedback to help us enhance your video 
                downloading experience.
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-section">
            <h2>Send Us a Message</h2>
            <p className="form-description">
              Fill out the form below and we'll get back to you as soon as possible. Please 
              provide detailed information about your YouTube or TikTok download issue for 
              faster assistance.
            </p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Your Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your.email@example.com"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a topic</option>
                  <option value="youtube-support">YouTube Download Support</option>
                  <option value="tiktok-support">TikTok Download Support</option>
                  <option value="technical-issue">Technical Issue / Bug Report</option>
                  <option value="broken-link">Broken Link / Error</option>
                  <option value="feature-request">Feature Request</option>
                  <option value="feedback">General Feedback</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Please describe your issue or question in detail. Include the video URL if you're reporting a download problem."
                  rows="6"
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-button">
                Send Message
              </button>
            </form>
          </div>

          {/* Common Issues */}
          <div className="common-issues">
            <h2>Common Issues & Quick Solutions</h2>
            <div className="issues-grid">
              <div className="issue-item">
                <h4>❌ Download Not Working</h4>
                <p>
                  <strong>Solution:</strong> Check if the video is public, clear your browser 
                  cache, try a different browser, or verify the URL is correct.
                </p>
              </div>

              <div className="issue-item">
                <h4>🔗 Invalid URL Error</h4>
                <p>
                  <strong>Solution:</strong> Ensure you're copying the complete video URL from 
                  YouTube or TikTok. The link should start with https://
                </p>
              </div>

              <div className="issue-item">
                <h4>🎥 Low Quality Video</h4>
                <p>
                  <strong>Solution:</strong> Select HD quality option before downloading. Some 
                  videos may not be available in higher resolutions.
                </p>
              </div>

              <div className="issue-item">
                <h4>💧 Watermark Still Present</h4>
                <p>
                  <strong>Solution:</strong> Make sure you're using the "No Watermark" download 
                  option for TikTok videos. This feature is automatic for most videos.
                </p>
              </div>

              <div className="issue-item">
                <h4>⏱️ Slow Download Speed</h4>
                <p>
                  <strong>Solution:</strong> Check your internet connection. Large HD videos 
                  take longer to process. Try downloading during off-peak hours.
                </p>
              </div>

              <div className="issue-item">
                <h4>📱 Mobile Issues</h4>
                <p>
                  <strong>Solution:</strong> Ensure JavaScript is enabled. Try using Chrome or 
                  Safari browser. Clear app cache if using in-app browser.
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="contact-faq">
            <h2>Frequently Asked Questions</h2>
            
            <div className="faq-item">
              <h4>How long does it take to get a response?</h4>
              <p>
                We typically respond to all inquiries within 24-48 hours. For urgent technical 
                issues affecting YouTube or TikTok downloads, we prioritize faster responses.
              </p>
            </div>

            <div className="faq-item">
              <h4>Do you provide phone support?</h4>
              <p>
                Currently, we provide support through our contact form and email. This allows 
                us to better track and resolve YouTube downloader and TikTok downloader issues 
                with detailed documentation.
              </p>
            </div>

            <div className="faq-item">
              <h4>Can you help with copyright issues?</h4>
              <p>
                YT DOWN is a tool for personal use. We encourage users to respect copyright 
                laws and content creators' rights. For copyright concerns, please contact the 
                original content owner directly.
              </p>
            </div>

            <div className="faq-item">
              <h4>How do I report a security issue?</h4>
              <p>
                If you've discovered a security vulnerability in our YouTube or TikTok video 
                downloader, please contact us immediately using the form above with "Security 
                Issue" in the subject line.
              </p>
            </div>
          </div>

          {/* Privacy Note */}
          <div className="privacy-note">
            <div className="privacy-icon">🔒</div>
            <div className="privacy-content">
              <h3>Your Privacy Matters</h3>
              <p>
                We respect your privacy and do not store any personal data, download history, 
                or video URLs. Your contact information is only used to respond to your inquiry 
                and is never shared with third parties. All communications are secure and 
                confidential.
              </p>
              <p>
                <strong>We do not:</strong> Store downloaded videos • Track your downloads • 
                Collect browsing data • Share your information • Send spam emails
              </p>
            </div>
          </div>

          {/* Alternative Contact */}
          <div className="alternative-contact">
            <h2>Other Ways to Reach Us</h2>
            <div className="contact-methods">
              <div className="method-card">
                <div className="method-icon">📧</div>
                <h4>Email Support</h4>
                <p>ramsis.nagham@outlook.com</p>
                <span className="response-time">Response within 24-48 hours</span>
              </div>

              <div className="method-card">
                <div className="method-icon">💬</div>
                <h4>Live Chat</h4>
                <p>Coming Soon</p>
                <span className="response-time">Instant support (in development)</span>
              </div>

              <div className="method-card">
                <div className="method-icon">📚</div>
                <h4>Help Center</h4>
                <p>Visit our FAQ section</p>
                <span className="response-time">Self-service support</span>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="contact-cta">
            <h2>Need Immediate Help?</h2>
            <p>
              Check our FAQ section or try our YouTube and TikTok video downloader again. 
              Most issues can be resolved by refreshing the page or trying a different browser.
            </p>
            <a href="/" className="cta-button">Back to Downloader</a>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Contact;
